/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".notificationContainer[_ngcontent-%COMP%]{overflow:auto}.version-tag[_ngcontent-%COMP%]{position:fixed;bottom:10px;z-index:1000;transition:.5s;left:100px;-webkit-transform:translate(-200px);transform:translate(-200px)}.version-tag.show-version[_ngcontent-%COMP%]{-webkit-transform:translate(0);transform:translate(0)}"];
export { styles as styles };
